export default {"src":"/_next/static/media/img_emerg.245916c1.svg","height":100,"width":94,"blurWidth":0,"blurHeight":0};